import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'info-content',
  templateUrl: 'info-content.html'
})
export class InfoContent {
  @Input() ionIcon: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() titleParams: any = {};
  @Input() subtitle: string;
  @Input() subtitle2: string;
  @Input() link: string;
  @Input() subtitleParams: any = {};
  @Input() msg: string;
  @Input() msgParams: any = {};
  @Output() linkEmitter = new EventEmitter<any>();


  ngOnInit() {}

  constructor() {}

  doAction() {
    this.linkEmitter.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/myria/info-content/info-content.ts